import { render, staticRenderFns } from "./TimetableSplitViewTable.vue?vue&type=template&id=34d9dc6a&"
import script from "./TimetableSplitViewTable.vue?vue&type=script&lang=js&"
export * from "./TimetableSplitViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports